export default {
  solutionAttachments: [],
  solutionAttachment: undefined,
};
